/**
 * A new starter's first afternoon.
 *
 * Nothing in here is said to the player. It is where things already are on
 * the day somebody new comes in, and the one thing that happens in front of
 * them. Read by `beginOpening` and `runOpening` in `main.js`, and only for a
 * week that started at the hiring screen.
 *
 *   arrive    where they come in, in feet, and which way they are facing: the
 *             staff lot, looking at the apron gate, because that is the way
 *             staff come in
 *   minutes   what time it is when they do. Half past one, a minute in: the
 *             clock opens at one for a two o'clock start and Serg is on at
 *             half past, so he is at the clock when they get there. It was ten
 *             past, which at full speed got a new starter there as he came on;
 *             the guided day runs the clock at a quarter (`tutorial.js`), so
 *             they got there before him and he never said his line. Twenty-nine
 *             game minutes is about two real ones at that pace, so a new
 *             starter who has to change first is still not late
 *   incident  how near, and how squarely in front of the player, the one
 *             thing that happens by somebody else has to be: `reach` feet at
 *             most, and `eyeline` the least the player can be facing it (a
 *             cosine), because a thing the player did not see teaches nothing.
 *             And `close`: how near the colleague who sees it has to be to the
 *             one who does it. Across a ballroom, a pocketed pastry is a
 *             glimpse nobody acts on; at arm's length it is a thing somebody
 *             has to decide about, and the deciding is the lesson.
 *             Who does it and who sees it are on their own rows in `staff.js`,
 *             under `firstDay`, because who people are is that file's business
 */
export const OPENING = Object.freeze({
  arrive: { at: [-24, -86], faces: [0, -63] },
  minutes: 13 * 60 + 31,
  incident: { reach: 45, eyeline: 0.64, close: 10 },
});

export default OPENING;
